import { render } from "./CityPoolDashboard.vue?vue&type=template&id=6845c365&scoped=true"
import script from "./CityPoolDashboard.vue?vue&type=script&lang=js"
export * from "./CityPoolDashboard.vue?vue&type=script&lang=js"

import "./CityPoolDashboard.vue?vue&type=style&index=0&id=6845c365&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6845c365"]])

export default __exports__